import { tracs_api } from "../../services/api.interceptor";


class BulkImportService{

    getDataTables(){
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "BulkImport/GetDataTables");
    }

    getTocs(){
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "BulkImport/GetTocs");
    }

    getSchema(tableId:number,tocId:string){
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "BulkImport/GetSchema?tableId="+tableId+"&tocId="+tocId);
    }

    updateTableData(data:any){
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "BulkImport/UpdateTableData",data);
    }

}
export default new BulkImportService();